import{j as s}from"./chunk-GEPA7FLG.js";s();var n=e=>{for(let o in e)document.documentElement.style.setProperty(`--${o}`,e[o])};export{n as a};
//# sourceMappingURL=chunk-UPUCK3AR.js.map
